import Base from '../../base';
import Table from './calculator-table';

class CalculatorTableDefault extends Base {
	constructor(el, options) {
		super(el, options);

		this.table = new Table(this.el, this.refs, this.options);
	}

	update(response) {
		this.table.update(response);
	}
}

export default CalculatorTableDefault;
